const Nominal = `
  id
  description
  label
  updatedAt
`;

export default Nominal;
